__turbopack_context__.v({
  "closing": "Menu-module-scss-module__VRJdlq__closing",
  "menu": "Menu-module-scss-module__VRJdlq__menu",
  "menu-animation": "Menu-module-scss-module__VRJdlq__menu-animation",
  "open": "Menu-module-scss-module__VRJdlq__open",
  "opening": "Menu-module-scss-module__VRJdlq__opening",
  "popper": "Menu-module-scss-module__VRJdlq__popper",
});
